import ResultCenter from '@/domain/result-center/entity/result-center.entity';

export default class EmployeeApportionment {
  id: string;

  resultCenter: ResultCenter;

  percentage: number;

  loadingDelete: boolean = false;

  tempId: string;

  showDeleteModal: boolean = false;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.tempId = obj.id ? obj.id : `temp-${Math.random().toString(36).substring(2, 9)}`;
    this.resultCenter = obj.resultCenter;
    this.percentage = obj.percentage || 0;
  }
}
